const RelatoriosHome = () => import(/* webpackChunkName: "group-pabx-relatorio" */ '../views/relatoriosHome')

import relatorioChamadasRoutes from '../modules/chamadas/_routes'
import relatorioConferenciaRoutes from '../modules/conferencias/_routes'

import { permissionsPabx } from '../../../utils/permissionsPabx'

export default [
  {
    path: 'relatorios',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: RelatoriosHome,
    children: [...relatorioChamadasRoutes, ...relatorioConferenciaRoutes],
  },
]
